"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrganizationProductTemplate = exports.getNewProductTemplate = exports.getProductsExport = exports.getProducts = void 0;
const shared_1 = require("@getgreenline/shared");
const url = (companyId) => `/api/v2/companies/${companyId}/products`;
const getProducts = (companyId, filter) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(url(companyId), {
        params: Object.assign(Object.assign({}, filter), { updateDate: JSON.stringify(filter.updateDate) }),
    });
    return response.data;
});
exports.getProducts = getProducts;
const getProductsExport = (companyId, filter) => __awaiter(void 0, void 0, void 0, function* () { return (yield shared_1.axios.get(`${url(companyId)}/export`, { params: filter })).data; });
exports.getProductsExport = getProductsExport;
/**
 * Returns a signed URL to download a new bulk-product template file.
 * @param companyId The company ID.
 * @param posProvider (Optional) The POS provider.
 */
const getNewProductTemplate = (companyId, posProvider) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`${url(companyId)}/template`, {
        headers: posProvider ? { 'x-pos-provider': posProvider } : undefined,
    });
    return response.data;
});
exports.getNewProductTemplate = getNewProductTemplate;
/**
 * Returns a signed URL to download the organization bulk product template file.
 * @param organizationId The organization ID.
 * @param posProvider (Optional) The POS provider.
 */
const getOrganizationProductTemplate = (organizationId, posProvider) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`/api/v1/organizations/${organizationId}/products/template`, {
        headers: posProvider ? { 'x-pos-provider': posProvider } : undefined,
    });
    return response.data;
});
exports.getOrganizationProductTemplate = getOrganizationProductTemplate;
//# sourceMappingURL=productV2.js.map